export default __webpack_public_path__ + "static/media/Img6.ad591974.png";